function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.2 18.8c-1-1-2.3-1.6-3.7-1.6h-7.9c-1.4 0-2.8.6-3.7 1.6-1 1-1.5 2.4-1.5 3.8V25c0 .4.3.8.8.8s.8-.3.8-.8v-2.3c0-1.1.4-2 1.1-2.8.7-.7 1.7-1.1 2.7-1.1h7.9c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.8V25c0 .4.3.8.8.8s.8-.3.8-.8v-2.3c-.3-1.5-.9-2.8-1.9-3.9zm-7.7-4c2.9 0 5.3-2.4 5.3-5.3s-2.4-5.3-5.3-5.3-5.3 2.4-5.3 5.3 2.4 5.3 5.3 5.3zm0-9c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8s1.7-3.8 3.8-3.8z"
});
function SvgClients(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref);
}
export default SvgClients;